import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {IGroupsRepository} from "@/repository/groups/GroupsRepository.types";
import {GroupName, GroupsResponseType, IGroups} from "@/entity/groups/groups.types";
import Groups from "@/entity/groups/groups";

export class GroupsRepository implements IGroupsRepository {
    async fetchAll(): Promise<IGroups[]> {
        const resp = await Api.get('/salons/groups/get');
        const respData = resp.data as GroupsResponseType[];
        return respData.map((group: GroupsResponseType) => new Groups(group));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/salons/groups/delete', data);
        return resp.data;
    }
    async create(data: GroupName): Promise<ResponseDataType> {
        const resp = await Api.post('/salons/groups/create', data)
        return  resp.data
    }
}